import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Assistant replies. react-markdown never renders raw HTML, so model output
 *  can't inject markup; links open in a new tab. */
export default function Markdown({ text }: { text: string }) {
  return (
    <div className="text-base leading-7 text-mut-100 space-y-3 break-words [&_strong]:font-semibold">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ children }) => <h3 className="text-lg font-semibold mt-5">{children}</h3>,
          h2: ({ children }) => <h3 className="text-lg font-semibold mt-5">{children}</h3>,
          h3: ({ children }) => <h4 className="text-base font-semibold mt-4">{children}</h4>,
          p: ({ children }) => <p>{children}</p>,
          ul: ({ children }) => <ul className="list-disc pl-5 space-y-1">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal pl-5 space-y-1">{children}</ol>,
          a: ({ href, children }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent-azure underline underline-offset-2"
            >
              {children}
            </a>
          ),
          code: ({ children }) => (
            <code className="font-mono text-sm px-1 py-0.5 rounded bg-fg/[0.06]">{children}</code>
          ),
          blockquote: ({ children }) => (
            <blockquote className="border-l-2 border-fg/[0.15] pl-3 text-mut-300">
              {children}
            </blockquote>
          ),
          table: ({ children }) => (
            <div className="overflow-x-auto rounded-xl border border-fg/[0.08]">
              <table className="w-full text-md">{children}</table>
            </div>
          ),
          thead: ({ children }) => <thead className="bg-ink-800 text-left">{children}</thead>,
          th: ({ children }) => (
            <th className="px-3 py-2 font-semibold text-sm text-mut-300">{children}</th>
          ),
          td: ({ children }) => (
            <td className="px-3 py-2 border-t border-fg/[0.06] align-top">{children}</td>
          ),
          hr: () => <hr className="border-fg/[0.08]" />,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
